import React from "react";
import {
  FaDesktop, FaTools, FaTruck, FaBuilding,
  FaBoxes, FaClipboardList, FaCogs, FaWarehouse
} from "react-icons/fa";

const useCases = [
  {
    icon: <FaDesktop />,
    title: "Office Equipment",
    desc: "Track computers, monitors, printers, and other office gear. Know what's assigned, what's available, and when warranties expire."
  },
  {
    icon: <FaTools />,
    title: "Tools & Instruments",
    desc: "Manage hand tools, power tools, testing instruments, and specialized equipment. Schedule calibration and servicing easily."
  },
  {
    icon: <FaTruck />,
    title: "Vehicles & Fleet",
    desc: "Keep track of company vehicles, delivery trucks, or service vans. Monitor mileage, service dates, and insurance renewals."
  },
  {
    icon: <FaCogs />,
    title: "Machinery & Equipment",
    desc: "Manage heavy or light equipment with preventive maintenance schedules, usage logs, and condition tracking."
  },
  {
    icon: <FaBuilding />,
    title: "Facility Assets",
    desc: "Track HVAC systems, lighting, elevators, and building infrastructure. Stay on top of inspections and servicing."
  },
  {
    icon: <FaBoxes />,
    title: "Inventory & Supplies",
    desc: "Monitor stock levels of spare parts, consumables, and supplies. Get alerts when items run low so you can reorder on time."
  },
  {
    icon: <FaClipboardList />,
    title: "Safety Equipment",
    desc: "Track fire extinguishers, PPE, first aid kits, and safety devices. Never miss an inspection or replacement date."
  },
  {
    icon: <FaWarehouse />,
    title: "Storage & Furniture",
    desc: "Manage desks, chairs, shelving, cabinets, and storage units across locations. Track assignments and condition."
  }
];

const ModuleSection = () => {
  return (
    <section id="industries" className="lp-modules">
      <div className="lp-modules__inner">
        <div className="lp-section-header">
          <span className="lp-section-tag">What You Can Track</span>
          <h2>Manage Any Type of Asset</h2>
          <p>
            From everyday office items to heavy equipment — organize, track, and
            maintain everything your team relies on.
          </p>
        </div>

        <div className="lp-modules__grid">
          {useCases.map((m, i) => (
            <div className="lp-modules__card" key={i}>
              <div className="lp-modules__icon">{m.icon}</div>
              <h3>{m.title}</h3>
              <p>{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModuleSection;
